/** The console roles a `console` request can ask for on one service.
 *
 * `sql-console-readonly` and `sql-console-admin` are SQL console's own
 * read-only and admin access. `service-reader` and `service-admin` copy the
 * service permissions of ClickHouse Cloud's system roles Service Reader and
 * Service Admin when the request is granted. */
export const CLICKHOUSE_CONSOLE_ROLES = [
  "sql-console-readonly",
  "sql-console-admin",
  "service-reader",
  "service-admin",
] as const;
export type ClickHouseConsoleRole = (typeof CLICKHOUSE_CONSOLE_ROLES)[number];
